module.exports = __webpack_public_path__ + "d5ef9ab9891bbc6a0f8416e814b145ac.png";